import { cn } from 'support/helpers/cn/cn';

export const BASE_CLASSES = 'mx-auto overflow-x-auto bg-white overflow-y-hidden';
export const BORDER_BOTTOM_CLASSES = 'border-b border-gray-200';
export const STICKY_CLASSES = 'sticky top-0 z-20';
export const TRANSITION_CLASSES = 'transition-transform duration-300 ease-in-out';
export const STICKY_WITH_TRANSITION = 'sticky z-20 transition-all duration-300 ease-in-out';

type PaddingConfig = {
  top: boolean;
  bottom: boolean;
  left: boolean;
  right: boolean;
};

type PaddingOptions = {
  skipTop?: boolean;
  skipBottom?: boolean;
  reducedTop?: boolean;
};

export const getPaddingClasses = (paddingConfig: PaddingConfig, options?: PaddingOptions) =>
  cn(
    options?.reducedTop ? 'pt-2' : options?.skipTop ? undefined : paddingConfig.top ? 'pt-3' : undefined,
    options?.skipBottom ? undefined : paddingConfig.bottom ? 'pb-3' : undefined,
    paddingConfig.left ? 'pl-4 sm:pl-6 md:pl-8' : undefined,
    paddingConfig.right ? 'pr-4 sm:pr-6 md:pr-8' : undefined,
  );

type BorderConfig = {
  bottom: boolean;
};

export const getBorderClasses = (borderConfig: BorderConfig, onlyWhenNoChildren = false, hasChildren = false) => {
  if (onlyWhenNoChildren) {
    return borderConfig.bottom && !hasChildren ? BORDER_BOTTOM_CLASSES : '';
  }
  return borderConfig.bottom ? BORDER_BOTTOM_CLASSES : '';
};
